/**
 *
 * @param start - Typically the start property from a timeslot object.
 * @param end - Typically the end property from a timeslot object
 * @returns lowercased versions of start and end with a '–' in between. example: 9 am-10 am
 */
export const formatTimeslot = (start: string, end: string) =>
  `${start.toLocaleLowerCase()}–${end.toLocaleLowerCase()}`
